export function validateUSState(value) {
    if(value === 'Select' || value === '') {
        return {
            value: value,
            isValid : false,
            message : "Error: Please select a State."
        }
    } else {
        return {
            value: value,
            isValid : true,
            message : ""
        }
    }
}
export default validateUSState;


// WEBPACK FOOTER //
// ./src/helper/validateUSState.js